import React from 'react';
import PropTypes from 'prop-types';

/**
 * Centered empty-state block (spec §9 / detail-page spec §6). Names the
 * active filters in `description` rather than a bare "no results".
 */
function EmptyState({ icon, title, description }) {
	return (
		<div className='tw:px-8 tw:py-12 tw:text-center'>
			{icon && <div className='tw:mb-3 tw:flex tw:justify-center tw:text-[32px] tw:text-ink-4'>{icon}</div>}
			<h4 className='tw:m-0 tw:text-[15px] tw:font-semibold tw:text-ink-0'>{title}</h4>
			{description && (
				<p className='tw:mx-auto tw:mt-1.5 tw:mb-0 tw:max-w-[360px] tw:text-[13px] tw:text-ink-2'>{description}</p>
			)}
		</div>
	);
}

EmptyState.propTypes = {
	icon: PropTypes.node,
	title: PropTypes.node.isRequired,
	description: PropTypes.node,
};

export default EmptyState;
